<template>
  <div>
    <div class="d-none d-md-block">
      <v-timeline align-top dense v-if="!isHolidaysEmpty()">
        <timeline-regular :data="{ ...holidays.today, title: 'Today' }" />
        <timeline-regular :data="{ ...holidays.tomorrow, title: 'Tomorrow' }" />
        <timeline-regular :data="{ ...holidays.next, title: 'Upcoming' }" />
      </v-timeline>
      <div v-else>
        <v-img src="/no-holidays.svg" :contain="true" height="300" />
      </div>
    </div>

    <div class="d-md-none">
      <div v-if="!isHolidaysEmpty()">
        <timeline-small :data="{ ...holidays.today, title: 'Today' }" />
        <v-divider />
        <timeline-small :data="{ ...holidays.tomorrow, title: 'Tomorrow' }" />
        <v-divider />
        <timeline-small :data="{ ...holidays.next, title: 'Upcoming' }" />
      </div>
      <div v-else>
        <v-img src="/no-holidays.svg" :contain="true" height="300" />
      </div>
    </div>
  </div>
</template>

<script>
import TimelineRegular from "@/views/protected/dashboard/timeline-regular";
import TimelineSmall from "@/views/protected/dashboard/timeline-small";

export default {
  name: "ActivitiesHolidays",
  props: ["holidays"],
  components: {
    TimelineSmall,
    TimelineRegular,
  },
  methods: {
    isHolidaysEmpty() {
      if (!this.holidays) return true;
      if (
        !this.holidays.next &&
        !this.holidays.today &&
        !this.holidays.tomorrow
      ) {
        return true;
      }
      return (
        !this.holidays.next.data &&
        !this.holidays.tomorrow.data &&
        !this.holidays.today.data
      );
    },
  },
};
</script>

<style scoped>
</style>
